/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectFeFleetTemperatureSensor
 */
export interface MonitoredObjectFeFleetTemperatureSensor {
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetTemperatureSensor
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetTemperatureSensor
     */
    sensorName: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetTemperatureSensor
     */
    sensorType?: MonitoredObjectFeFleetTemperatureSensorSensorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectFeFleetTemperatureSensor
     */
    sensorZone?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetTemperatureSensor
     */
    serialNumber: string;
}

export function MonitoredObjectFeFleetTemperatureSensorFromJSON(json: any): MonitoredObjectFeFleetTemperatureSensor {
    return MonitoredObjectFeFleetTemperatureSensorFromJSONTyped(json, false);
}

export function MonitoredObjectFeFleetTemperatureSensorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectFeFleetTemperatureSensor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'sensorName': json['sensor_name'],
        'sensorType': !exists(json, 'sensor_type') ? undefined : json['sensor_type'],
        'sensorZone': !exists(json, 'sensor_zone') ? undefined : json['sensor_zone'],
        'serialNumber': json['serial_number'],
    };
}

export function MonitoredObjectFeFleetTemperatureSensorToJSON(value?: MonitoredObjectFeFleetTemperatureSensor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sensor_name': value.sensorName,
        'sensor_type': value.sensorType,
        'sensor_zone': value.sensorZone,
        'serial_number': value.serialNumber,
    };
}

/**
* @export
* @enum {string}
*/
export enum MonitoredObjectFeFleetTemperatureSensorSensorTypeEnum {
    TemperatureSensor = 'temperature_sensor'
}


